<template>
  <div
      v-show="total > 0"
      :class="{ center: center, 'pagination-container': true, padding0: small }"
  >
  <el-pagination
        :current-page="page"
        :page-size="limit"
        :total="total"
        :small="small"
        :layout="layout"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from './scroll-to'
export default {
  name: 'Pagination',
  //接收父组件传的值
  props: {
    // 总数
    total: {
      required: true,
      type: Number,
    },
    // 当前页
    page: {
      type: Number,
      default: 1,
    },
    // 每页显示条数
    limit: {
      type: Number,
      default: 10,
    },
    // 每页显示条数筛选列表
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 50, 100, 500]
      },
    },
    // 功能
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },
    // 背景
    background: {
      type: Boolean,
      default: true,
    },
    // 是否居中
    center: {
      type: Boolean,
      default: false,
    },
    // 小型分页
    small: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    total(val) {
      let page = this.page
      const newPage = Math.ceil(val / this.limit) || 1
      //如果当前不是第一页就让页数减1
      if (page > newPage) {
        page--
        this.handleCurrentChange(page)
      }
    },
  },

  methods: {
    // 每页条数改变
    handleSizeChange(val) {
      if (this.page * val > this.total) {
        this.page = 1
      }
      //触发父组件每页条数的改变,修改父组件limit的值
      this.$emit('update:limit', val)
      //通过pagination方法调用父组件的getList的接口
      this.$emit('pagination', { page: this.page, limit: val })
    },

    // 当前页改变
    handleCurrentChange(val) {
      //触发父组件当前页数的改变,修改父组件page的值
      this.$emit('update:page', val)
      //通过pagination方法调用父组件的getList的接口
      this.$emit('pagination', { page: val, limit: this.limit })
    },
  },
}
</script>
<style  scoped>
.el-pager li .number active{
  color:white;
}
.pagination-container {
  background: #fff;
  padding: 32px 16px;
}
.pagination-container.hidden {
  display: none;
}
.pagination-container {
  display: flex;
  padding: 15px 20px;
  background: #fff;
}
.center {
  justify-content: center;
}
.pagination-container .el-pagination {
  margin-left: auto;
  font-weight: normal;
}
.pagination-container.center .el-pagination {
  margin: 0 auto;
}
.padding0 {
  padding: 0;
}

</style>
